import IntegrationMessageDetailPage from '../shared/IntegrationMessageDetailPage';

const EmailOutboxMessageDetailPage = () => (
    <IntegrationMessageDetailPage kind="emailOutbox" />
);

export default EmailOutboxMessageDetailPage;
